import { create } from 'zustand';
import {
  getCertifications,
  getLearnerProgress,
  getCertificationStats,
  Certification,
  Learner,
  CertificationStats,
} from '@/services/PagesServices/CertificationManagementService';

interface CertificationManagementState {
  certifications: Certification[] | null;
  learnerProgress: Learner[] | null;
  certificationStats: CertificationStats | null;
  loading: boolean;
  error: string | null;

  fetchCertifications: () => Promise<void>;
  fetchLearnerProgress: () => Promise<void>;
  fetchCertificationStats: () => Promise<void>;
}

const useCertificationManagementStore = create<CertificationManagementState>((set, get) => ({
  certifications: null,
  learnerProgress: null,
  certificationStats: null,
  loading: false,
  error: null,

  fetchCertifications: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getCertifications();
      set({ certifications: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchLearnerProgress: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getLearnerProgress();
      set({ learnerProgress: response.data || [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchCertificationStats: async () => {
    try {
      set({ loading: true, error: null });
      const response = await getCertificationStats();
      set({ certificationStats: response.data || null, loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useCertificationManagementStore;
